import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "components/common/loader";
import CustomModal from "components/common/modal";
import TableWrapper from "components/common/table-wrapper";
import RadioButton from "components/common/radio-button/RadioButton";
import AddTaskForm from "./AddTaskForm";
import moment from "moment";
import Tooltip from "components/common/tooltip";
import {
  formatString,
  getUserInfo,
  capitalizeName,
  formatDate,
  getUserRole,
  canApproveRejectExpenseRequests,
  canCreateExpenseRequests,
  DateFormat,
} from "utils/common";
import AsyncSelect from "components/common/select/AsyncSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import Input from "components/common/input";
import SelectComponent from "components/common/select";
import Addmemberform from "../members/Addmemberform";
// API imports
import { createMember, getMember, updateMember } from "containers/members/api";
import {
  createSurveyComment,
  discardSurvey,
  getSurveyComments,
  getSurveyHistory,
  updateSurveyComment,
  addTask,
  updateTask,
  getActiveUsers,
  createExpenseAuthorization,
  updateExpenseAuthorization,
} from "containers/survey/api";

// Icons and Assets
import {
  ArrowLeft,
  Pencil,
  Plus,
  User,
  CaretRight,
  CaretDown,
  Eye,
  FileText,
  Trash,
  DownloadSimple,
  X,
  Check as CheckIcon,
  CurrencyDollar,
} from "phosphor-react";
import OutreachStafIcon from "assets/images/outreach-staf-icon.svg";

// Utils and Constants
import {
  initialMetaForTable,
  statusBadge,
  statusBadgeStyles,
} from "constants/common";
import ApprovalStepper from "components/common/approval-stepper/ApprovalStepper";
import CreateHousingExpenseForm from "components/housing-expense-request/CreateForm";

import DateInput from "components/common/date-picker";

// Styles
import "./survey.scss";
import { useDebouncedTemplateDataCallback } from "utils/debouncedHelper";
import { getTemplates } from "containers/templates/api";
import { HOUSING_EXPENSE_CREATE_REQUEST_PATH } from "constants/routePaths";
import AddExpenseWithMember from "components/housing-expense-request/AddExpenseWithMember";
// import AddFormWithoutMember from "components/housing-expense-request/AddFormWithoutMember";
import { getExpenseCategories } from "containers/configuration/api";
import RejectForm from "components/housing-expense-request/modals/PaymentRejectForm";
import PaymentForm from "components/housing-expense-request/modals/PaymentForm";
import { ApprovedHousingExpense, RejectedHousingExpense } from "containers/housing-expense-requests/api";
import HousingPaymentForm from "components/housing-expense-request/modals/HousingPaymentForm";
export const HeaderCard = ({ icon, title, subTitle }) => {
  return (
    <div className="d-flex align-items-center header-card">
      {icon ? <div className="icon">{icon}</div> : null}
      <div className="d-flex flex-column justify-content-between flex-grow-1 flex-basis-0">
        <span className="heading-xs title text-nowrap">{title}</span>
        <span
          className="heading-smb sub-title"
          style={{ whiteSpace: "normal", wordBreak: "break-word" }}
        >
          {subTitle}
        </span>
      </div>
    </div>
  );
};
const memberInfoTransform = (member = {}) => {
  const homeAddr =
    member?.addresses?.find((a) => a.address_type === "home") || {};
  const mailingAddr =
    member?.addresses?.find((a) => a.address_type === "mailing") || {};
  const buildAddress = (addr) =>
    [addr?.street, addr?.city?.name, addr?.state?.name, addr?.zip_code?.name]
      .filter(Boolean)
      .join(", ");

  return {
    ...member,
    memberID: member?.id,
    memberName: `${member?.first_name || ""} ${member?.last_name || ""}`.trim(),
    memberAccountNo: member?.account_number,
    memberpreferred_spoken_lang: member?.member_preferred_language_spoken || "",
    medical_record_number: member?.medical_record_number || "",
    cin: member?.cin || "",
    enrollment_status: member?.enrollment_status || "",
    mif: member?.mif || "",
    mif_status: member?.mif_status || "",
    date_of_birth: member?.date_of_birth || "",
    city: member?.city || "",
    created_at: member?.created_at || "",
    updated_at: member?.updated_at || "",
    checked: member?.checked || "",
    zip_code: member?.zip_code?.code || "",
    county: member?.county?.name ? `(${member?.county?.name} County)` : "",
    state: member?.state,
    outreach_staff: member?.outreach_staff?.name || "",
    health_plan: member?.health_plan?.name || "",
    housing_navigator: member?.housing_navigator || "",
    cs_manager: member?.cs_manager || "",
    population_focuses: member?.population_focus || "",
    conditions: member?.conditions || "",
    street: member?.street || "",

    // New values
    preferred_spoken_language: member?.preferred_spoken_language || "",
    preferred_written_language: member?.preferred_written_language || "",
    homeAddress: member?.home_address || "",
    // homeCity: member.homeCity || "",
    // homeState: member.homeState || "",
    // homeZip: member.homeZip || "",
    mailingAddress: member?.mailing_address || "",
    // mailingCity: member.mailingCity || "",
    // mailingState: member.mailingState || "",
    // mailingZip: member.mailingZip || "",
    gender: member?.gender || "",
    race: member?.race || "",
    marital: member?.marital || "",
    aica_account: member?.aica_account || "",
    kipu_account_no: member?.kipu_account_no || "",
    kipu_ifmrn: member?.kipu_ifmrn || "",

    phone: member?.phone_number || "",
    email: member?.email || "",
    homeAddress: buildAddress(homeAddr),
    mailingAddress: buildAddress(mailingAddr),
    emergency_contact_name: member?.emergency_contact_name || "",
    emergency_contact_relationship:
      member?.emergency_contact_relationship || "",
    housing_database: member?.housing_database || "",
    housing_unit: member?.housing_unit || "",
    landlord_name: member?.landlord_name || "",
    // subscriber_id: member?.subscriber_id || "",
    phone: member?.phone_number || "",
    otherCommunicationPref: member?.otherCommunicationPref || "",
    referrals: member?.referrals || [],
    tasks: member?.tasks || [],
    authorizations: member?.authorizations || [],
    expense_authorizations: member?.expense_authorizations || [],
  };
};
const memberEditTransform = (member = {}) => {
  const homeAddr =
    member?.addresses?.find((a) => a.address_type === "home") || {};
  const mailingAddr =
    member?.addresses?.find((a) => a.address_type === "mailing") || {};

  return {
    ...member,
    first_name: member?.first_name || "",
    last_name: member?.last_name || "",
    date_of_birth: member?.date_of_birth || "",
    gender: member?.gender || "",
    race: member?.race || "",
    marital: member?.marital || "",
    preferred_spoken_language: member?.preferred_spoken_language || "",
    preferred_written_language: member?.preferred_written_language || "",
    phone_number: member?.phone_number || "",
    email: member?.email || "",
    home_street: homeAddr?.street || "",
    home_city: homeAddr?.city || "",
    home_state: homeAddr?.state || "",
    home_zip: homeAddr?.zip_code || "",
    home_county: homeAddr?.county || "",
    mailing_street: mailingAddr?.street || "",
    mailing_city: mailingAddr?.city || "",
    mailing_state: mailingAddr?.state || "",
    mailing_zip: mailingAddr?.zip_code || "",
    mailing_county: mailingAddr?.county || "",
    cin: member?.cin || "",
    aica_account: member?.aica_account || "",
    kipu_account_no: member?.kipu_account_no || "",
    kipu_ifmrn: member?.kipu_ifmrn || "",
    health_plan: member?.health_plan || "",
    cs_manager: member?.cs_manager
      ? `${member.cs_manager.first_name} ${member.cs_manager.last_name}`
      : "",
    housing_navigator: member?.housing_navigator?.id || "",
    emergency_contact_name: member?.emergency_contact_name || "",
    emergency_contact_relationship:
      member?.emergency_contact_relationship || "",
    population_focus: member?.population_focus || "",
    conditions: member?.conditions || "",
    housing_database: member?.housing_database || "",
    housing_unit: member?.housing_unit || "",
    landlord_name: member?.landlord_name || "",
  };
};

const SurveyHistory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    if (!id) {
      console.error("Member ID missing in URL");
      navigate("/", { replace: true });
    }
  }, [id, navigate]);

  const getRawMember = () => {
    try {
      const item = localStorage.getItem("member");
      if (item && item !== "undefined" && item !== "null") {
        return JSON.parse(item);
      }
    } catch (e) {
      console.warn("Failed to parse member:", e);
    }
    return null;
  };

  const [memberInfo, setMemberInfo] = useState({});
  console.log("member information", memberInfo);
  const [rawMember, setRawMember] = useState(getRawMember());
  const [editMemberData, setEditMemberData] = useState({});
  const [meta, setMeta] = useState({
    ...initialMetaForTable,
    id,
  });
  const [activeTab, setActiveTab] = useState("memberInfo");
  const [showDetailsId, setShowDetailsId] = useState("");
  const [currentTaskEdit, setCurrentTaskEdit] = useState("");
  const [loading, setLoading] = useState(true);
  const [surveyList, setSurveyList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [activeUsers, setActiveUsers] = useState([]);
  const [showMemberInfo, setShowMemberInfo] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showCompletedTaskModal, setShowCompletedTaskModal] = useState(false);
  const [selected, setSelected] = useState("");
  const [comment, setComment] = useState("");
  const [templatesList, setTemplatesList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
  const [showAuthPopup, setShowAuthPopup] = useState(false);
  const [modalStep, setModalStep] = useState(1);
  const [isExpenseModalOpen, setIsExpenseModalOpen] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState("");
  const [selectedExpenseRecord, setSelectedExpenseRecord] = useState(null);
  const [isViewExpenseVisible, setIsViewExpenseVisible] = useState(false);
  const [isEditExpenseVisible, setIsEditExpenseVisible] = useState(false);
  const [editExpenseRecord, setEditExpenseRecord] = useState(null);
  const [addNewMemberModal, setAddNewMemberModal] = useState(false);
  const [selectedAuth, setSelectedAuth] = useState(null);
  const [isEditingAuth, setIsEditingAuth] = useState(false);
  const [editMember, setEditMember] = useState(false);
  const [selectedMember, setSelectedMember] = useState("");
  const [refreshPage, setRefreshPage] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [filterMember, setFilterMember] = useState([]);
  const [isRejectedPaymentVisible, setIsRejectedPaymentVisible] = useState(false);
  const [isAcceptPaymentVisible, setIsAcceptPaymentVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const userInfo = getUserInfo();
  const currentUserId = userInfo?.id;
  const userRole = getUserRole();
  const canApproveReject = canApproveRejectExpenseRequests(userRole);
  const canCreateExpenseRequest = canCreateExpenseRequests(userRole);
  const isExecutive = userRole === "Executive";
  const isAccounting = userRole === "Accounting";
  const isProgramCoordinator = userRole === "ProgramCoordinator";
  const isHousingNavigator = userRole === "HousingNavigator";
  const isCsManager = userRole === "CsManager";

  const getAuthTypeLabel = (authType) => {
    const auth = authTypes.find(
      (type) => type.value === authType || type.label === authType
    );
    return auth ? auth.label : authType || "";
  };

  const getStatusClassName = (status) => {
    const statusMap = {
      completed: "completed",
      in_progress: "inProgress",
      approved: "approved",
      denied: "denied",
      draft: "draft",
      pending: "pending",
    };
    return statusMap[status] || "pending";
  };
  
  const getStatusDisplayText = (status) => {
    const statusMap = {
      completed: "Completed",
      in_progress: "In Progress",
      approved: "Approved",
      denied: "Denied",
      draft: "Draft",
      pending: "Pending",
    };
    return statusMap[status] || "Pending";
  };

  const handleOpenTemplateModal = () => {
    setIsTemplateModalVisible(true);
  };
  const handleCloseTemplateModal = () => {
    setIsTemplateModalVisible(false);
    setSelectedTemplate("");
  };
  const handleRefreshPage = () => {
    setRefreshPage((prev) => !prev);
  };
  const PROGRAMS = [
  {
    name: "CalAIM - CSS Housing",
    counties: [
      { county: "IE", key: "calaim_css_housing_ie_ifmrn", statusKey: "calaim_css_housing_ie_status" },
      { county: "LA", key: "calaim_css_housing_la_ifmrn", statusKey: "calaim_css_housing_la_status" },
      { county: "OC", key: "calaim_css_housing_oc_ifmrn", statusKey: "calaim_css_housing_oc_status" },
    ],
  },
  {
    name: "CalAIM - CSS Recup",
    counties: [
      { county: "IE", key: "calaim_css_recup_ie_ifmrn", statusKey: "calaim_css_recup_ie_status" },
      { county: "LA", key: "calaim_css_recup_la_ifmrn", statusKey: "calaim_css_recup_la_status" },
      { county: "OC", key: "calaim_css_recup_oc_ifmrn", statusKey: "calaim_css_recup_oc_status" },
    ],
  },
  {
    name: "CalAIM - CSS Short-Term Post-Hospitalization",
    counties: [
      { county: "IE", key: "calaim_css_short_term_ie_ifmrn", statusKey: "calaim_css_short_term_ie_status" },
      { county: "LA", key: "calaim_css_short_term_la_ifmrn", statusKey: "calaim_css_short_term_la_status" },
      { county: "OC", key: "calaim_css_short_term_oc_ifmrn", statusKey: "calaim_css_short_term_oc_status" },
    ],
  },
  {
    name: "CalAIM - CSS Tenancy/Sustainability",
    counties: [
      { county: "IE", key: "calaim_css_tenancy_ie_ifmrn", statusKey: "calaim_css_tenancy_ie_status" },
      { county: "LA", key: "calaim_css_tenancy_la_ifmrn", statusKey: "calaim_css_tenancy_la_status" },
      { county: "OC", key: "calaim_css_tenancy_oc_ifmrn", statusKey: "calaim_css_tenancy_oc_status" },
    ],
  },
];
  const authTypes = [
    {
      label: "Housing Navigation Authorization",
      value: "housing_navigation",
    },
    {
      label: "Housing Deposit Authorization",
      value: "housing_deposit",
    },
    {
      label: "Tenancy Authorization",
      value: "tenancy",
    },
  ];
  const approvalSteps = [
    {
      title: "Housing Navigator",
      name: "Wade Warren",
      status: "created",
      date: "Apr 3, 2023 at 7:19 PM",
    },
    {
      title: "CS Manager",
      name: "John Doe",
      status: "rejected",
      date: "Apr 3, 2023 at 7:19 PM",
      reason: "Incomplete/Incorrect Member Name",
    },
    {
      title: "Housing Navigator",
      name: "Wade Warren",
      status: "resubmitted",
      date: "Apr 3, 2023 at 7:19 PM",
    },
    {
      title: "CS Manager",
      name: "John Doe",
      status: "approved",
      date: "Apr 3, 2023 at 7:19 PM",
    },
    {
      title: "Executive",
      name: "John Doe",
      status: "approved",
      date: "Apr 3, 2023 at 7:19 PM",
    },
    {
      title: "Accounting Personnel",
      name: "John Doe",
      status: "completed",
      date: "Apr 3, 2023 at 7:19 PM",
    },
    { title: "Accounting Personnel", name: "John Doe" },
  ];

 const calculateHDABalance = () => {
  const balance = memberInfo?.total_balance;
   // const hda = memberInfo.expense_authorizations?.find(
    //   (auth) => auth.auth_type === "housing_deposit"
    // );

    // if (!hda || !hda.authorized_amount) {
    //   return "0.00";
    // }

    // const totalExpenses = expenses
    //   .filter((expense) => expense.affects_hda_balance)
    //   .reduce((sum, expense) => {
    //     return expense.is_addition
    //       ? sum + expense.amount
    //       : sum - expense.amount;
    //   }, 0);

    // const balance = (hda.authorized_amount || 0) - totalExpenses;
    // const newLocal = balance >= 0;
    // return newLocal ? balance.toFixed(2) : "0.00";

  if (balance === null || balance === undefined || isNaN(balance)) {
    return "0.00";
  }

  return Number(balance).toFixed(2);
};

  const fetchActiveUsers = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getActiveUsers();
      if (result["users"]) setActiveUsers(result.users);
    } catch (error) {
      console.error("Error fetching Users:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchSurveyHistory = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getSurveyHistory(meta);
      if (result["housing_expenses"]) setSurveyList(result.housing_expenses);
      setTotalCount(result?.meta.total_count);
    } catch (error) {
      console.error("Error fetching survey history:", error);
    } finally {
      setLoading(false);
    }
  }, [meta]);

  const fetchMember = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const result = await getMember(id);
      if (result["member"]) {
        const transformed = memberInfoTransform(result.member);
        const editData = memberEditTransform(result.member);
        setMemberInfo(transformed);
        setFilterMember(result.member);
        setRawMember(result.member);
        setEditMemberData(editData);
        await fetchSurveyComment(result.member.id);
        localStorage.setItem("member", JSON.stringify(result.member));
        // await fetchSurveyComment(result.member.id);
      }
    } catch (error) {
      console.error("Error fetching member:", error);
      if (error?.response?.status === 404) {
        navigate("/not-found", { replace: true });
      }
    } finally {
      setLoading(false);
    }
  }, [id, navigate]);

  const fetchExpenses = useCallback(async () => {
    if (!memberInfo.memberID) return;
    try {
      const result = await getExpenseCategories(memberInfo.memberID);
      if (result?.expenses) setExpenses(result.expenses);
    } catch (error) {
      console.error("Error fetching expenses:", error);
    }
  }, [memberInfo.memberID]);

  const fetchSurveyComment = async (memberId) => {
    try {
      const result = await getSurveyComments(memberId);
      if (result?.comments) setComment(result.comments[0]);
    } catch (error) {
      console.error("Error fetching survey comments:", error);
    }
  };

  // Comment handlers
  const handleCommentChange = (event) =>
    setComment((prev) => ({
      ...prev,
      content: event.target.value,
    }));
  const handleCommentUpdationOrCreation = async (event) => {
    const content = event.target.value;
    try {
      const result =
        !comment?.id && memberInfo
          ? await createSurveyComment(memberInfo.memberID, content)
          : await updateSurveyComment(comment?.id, content);

      if (result?.comment) {
        setComment(result.comment);
      }
    } catch (error) {
      console.error("Error updating/creating comment:", error);
    }
  };

  const handlePageChange = (value) =>
    setMeta((prev) => ({ ...prev, page: value }));

  const handleModalClose = (setFieldValue) => {
    setShowAuthPopup(false);
    setModalStep(1);
    setSelectedAuth(null);
    setIsEditingAuth(false);
    setFieldValue("newAuthorization", {
      type: null,
      auth_no: "",
      startDate: null,
      endDate: null,
      approvedDays: "",
      authorizedAmount: "",
    });
  };

  // const handleAuthSubmit = async (
  //   setFieldValue,
  //   values,
  //   validateForm,
  //   setErrors = () => { }
  // ) => {
  //   if (modalStep === 1) {
  //     const errors = await validateForm();
  //     if (!errors?.newAuthorization?.type) setModalStep(2);
  //   } else {
  //     try {
  //       const payload = {
  //         expense_authorization: {
  //           auth_type:
  //             values.newAuthorization.type?.value ||
  //             values.newAuthorization.type?.label,
  //           auth_no: values.newAuthorization.auth_no,
  //           start_date: values.newAuthorization.startDate
  //             ? moment(values.newAuthorization.startDate).format("YYYY-MM-DD")
  //             : null,
  //           end_date: values.newAuthorization.endDate
  //             ? moment(values.newAuthorization.endDate).format("YYYY-MM-DD")
  //             : null,
  //           approved_days: parseInt(values.newAuthorization.approvedDays),
  //           member_id: memberInfo.memberID,
  //         },
  //       };
  //       if (values.newAuthorization.type?.value === "housing_deposit") {
  //         payload.expense_authorization.authorized_amount = parseFloat(
  //           values.newAuthorization.authorizedAmount || 0
  //         );
  //       }

  //       let result;
  //       if (isEditingAuth && selectedAuth?.id) {
  //         result = await updateExpenseAuthorization(
  //           selectedAuth.id,
  //           payload,
  //           setErrors
  //         );
  //       } else {
  //         result = await createExpenseAuthorization(payload, setErrors);
  //       }
  //       if (result?.expense_authorization) {
  //         console.log("inside if result is ", result);
  //         handleModalClose(setFieldValue);
  //         fetchMember(); // Refresh member data to get updated authorizations
  //         fetchExpenses();
  //       }
  //     } catch (error) {
  //       console.log("inside catch", error);
  //       console.log("Error submitting authorization:", error?.response?.data);
  //     }
  //   }
  // };
  const handleAuthSubmit = async (
    setFieldValue,
    values,
    validateForm,
    setErrors = () => { }
  ) => {
    if (modalStep === 1) {
      const errors = await validateForm();
      if (!errors?.newAuthorization?.type) setModalStep(2);
    } else {
      // if (!isEditingAuth || isEditingAuth) {
      //   const existingOpenAuth = memberInfo.expense_authorizations?.find(
      //     (auth) => auth.expense_status?.toLowerCase() === "open"
      //   );

      //   if (existingOpenAuth) {
      //     const existingEndDate = moment(existingOpenAuth.end_date).startOf('day');
      //     const newStartDate = moment(values.newAuthorization.startDate).startOf('day');

      //     if (newStartDate.isSameOrBefore(existingEndDate)) {
      //       setErrors({
      //         apiError: `New authorization must start after the current one ends (${moment(existingEndDate).format("MM/DD/YYYY")}).`
      //       });
      //       return;
      //     }
      //   }
      // }

      try {
        const payload = {
          expense_authorization: {
            auth_type:
              values.newAuthorization.type?.value ||
              values.newAuthorization.type?.label,
            auth_no: values.newAuthorization.auth_no,
            start_date: values.newAuthorization.startDate
              ? moment(values.newAuthorization.startDate).format("YYYY-MM-DD")
              : null,
            end_date: values.newAuthorization.endDate
              ? moment(values.newAuthorization.endDate).format("YYYY-MM-DD")
              : null,
            approved_days: parseInt(values.newAuthorization.approvedDays),
            member_id: memberInfo.memberID,
            expense_status: moment(values.newAuthorization.startDate).isAfter(moment(), 'day')
              ? "pending"
              : "open"
          },
        };

        if (values.newAuthorization.type?.value === "housing_deposit") {
          payload.expense_authorization.authorized_amount = parseFloat(
            values.newAuthorization.authorizedAmount || 0
          );
        }

        let result;
        if (isEditingAuth && selectedAuth?.id) {
          result = await updateExpenseAuthorization(selectedAuth.id, payload, setErrors);
        } else {
          result = await createExpenseAuthorization(payload, setErrors);
        }

        if (result?.expense_authorization) {
          handleModalClose(setFieldValue);
          fetchMember();
          fetchExpenses();
          fetchSurveyHistory();
        }
      } catch (error) {
        console.log("Error submitting authorization:", error);
      }
    }
  };
  const getStatusConfig = (status) => {
    const normalized = status
      ?.toString()
      .trim()
      .toLowerCase();
    const map = {
      draft: { label: "Draft", class: "draft" },
      submitted: { label: "Submitted", class: "submitted-housing" },
      pending: { label: "Pending", class: "pending" },
      "housing-pending": { label: "Pending", class: "pending" },
      approved: { label: "Approved", class: "approved" },
      completed: { label: "Completed", class: "completed" },
      cancelled: { label: "Cancelled", class: "cancelled" },
      denied: { label: "Denied", class: "denied" },
    };
    return map[normalized] || { label: status || "—", class: "unknown" };
  };

  const handleMemberSubmission = async (member, setErrors) => {
    try {
      let result;
      if (rawMember) {
        result = await updateMember(member, id, setErrors);
      } else {
        result = await createMember(member, setErrors);
      }
      if (result) {
        setEditMember(false);
        handleRefreshPage();
        localStorage.setItem(
          "member",
          JSON.stringify(result?.member || member?.member)
        );
        setRawMember(result?.member || member?.member);
        setMemberInfo(memberInfoTransform(result?.member || member?.member));
        setEditMemberData(
          memberEditTransform(result?.member || member?.member)
        );
        fetchMember();
      }
    } catch (error) {
      console.error("Error saving member:", error);
    }
  };

  const handleEditModal = () => {
    setEditMember(true);
  };

  useEffect(() => {
    if (id) {
      fetchSurveyHistory();
      fetchMember();
      fetchActiveUsers();
    }
  }, [
    id,
    meta,
    refreshPage,
    // fetchSurveyHistory,
    // fetchMember,
    // fetchActiveUsers,
    // fetchExpenses,
  ]);
  useEffect(() => {
    if (id) {
      fetchExpenses();
    }
  }, [fetchExpenses]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Modal handlers
  const handleOpenDeleteModal = (id) => {
    setSelected(id);
    setShowDeleteConfirm(true);
  };

  const handleCloseDeleteModal = () => {
    setSelected("");
    setShowDeleteConfirm(false);
  };

  const handleCloseTaskModal = () => {
    setShowTaskModal(false);
    setCurrentTaskEdit(null);
  };

  const handleCloseCompletedTaskModal = () => {
    setShowCompletedTaskModal(false);
  };

  const handleTaskSubmission = async (task, setSubmitting) => {
    const isEditMode = Boolean(currentTaskEdit);
    try {
      const payload = {
        ...task,
        // user_id: getUserInfo()?.id,
        member_id: memberInfo.memberID,
        status: "open",
      };
      let result;
      if (isEditMode) {
        const currentTaskID = currentTaskEdit.id;
        result = await updateTask(currentTaskID, payload);
      } else {
        result = await addTask(payload);
      }

      if (result) {
        handleCloseTaskModal();
        fetchMember();
      }
    } catch (error) {
      console.error("Error submitting task:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleTaskStatus = async (task) => {
    try {
      const payload = {
        ...task,
        user_id: memberInfo?.tasks?.user?.name,
        member_id: memberInfo.memberID,
        status: "complete",
      };
      let result;
      const currentTaskID = task.id;
      result = await updateTask(currentTaskID, payload);

      if (result) {
        fetchMember();
      }
    } catch (error) {
      console.error("Error submitting task:", error);
    }
  };

  // Survey handlers
  const handleDiscard = async (surveyId) => {
    try {
      await discardSurvey(surveyId);
      setSurveyList((prev) => prev.filter((s) => s.id !== surveyId));
      setSurveyList((prevList) => {
        const updatedList = prevList.filter((survey) => survey.id !== surveyId);
        localStorage.setItem("surveyList", JSON.stringify(updatedList));
        return updatedList;
      });
    } catch (error) {
      console.error("Error discarding survey:", error);
    }
  };

  const handleContinue = (surveyId) => {
    const surveyExists = surveyList.some((survey) => survey.id === surveyId);
    navigate(surveyExists ? `/survey/${memberInfo.memberID}` : "/");
  };

  const handleDeleteConfirm = () => {
    handleDiscard(selected);
    handleCloseDeleteModal();
  };

  const toggleMemberInfo = () => {
    if (screenWidth <= 600) {
      setShowMemberInfo((prevState) => !prevState);
    }
  };
  const authFields = [
    { title: "Auth. No.", key: "auth_no" },
    { title: "Auth. Type", key: "auth_type" },
    { title: "Amount", key: "authorized_amount" },
    { title: "Start Date", key: "start_date" },
    { title: "End Date", key: "end_date" },
    {
      title: "Approved Days",
      key: "approved_days",
    },
    { title: "Status", key: "expense_status" },
  ];

  const fetchTemplates = useCallback(async () => {
    try {
      const result = await getTemplates(initialMetaForTable);
      if (result["templates"]) {
        const data = result?.templates.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setTemplatesList(data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const showAddress = (value) => {
    return (
      <>
        {value?.street && (
          <>
            {capitalizeName(value.street)},
            <br />
          </>
        )}

        {(value?.city?.name || value?.state?.name) && (
          <>
            {capitalizeName(value?.city?.name)}
            {value?.city?.name && value?.state?.name && ", "}
            {capitalizeName(value?.state?.name)}
            {value?.zip_code?.name && `, ${value.zip_code.name}`}
            <br />
          </>
        )}

        {value?.county?.name && <>({capitalizeName(value.county.name)})</>}
      </>
    );
  };


  const handleExpenseModalClose = () => {
    setIsExpenseModalOpen(false);
    setSelectedExpense("");
  };

  const handleOpenAddNewMemberModal = () => {
    setAddNewMemberModal(true);
  };

  const handleCloseAddNewMemberModal = () => {
    setAddNewMemberModal(false);
  };
  const handleOpenViewExpense = (expense) => {
    setSelectedExpenseRecord(expense);
    setIsViewExpenseVisible(true);
  };
  const handleCloseViewExpense = () => {
    setSelectedExpenseRecord(null);
    setIsViewExpenseVisible(false);
  };
  const handleOpenEditExpense = (expense) => {
    setEditExpenseRecord(expense);
    setIsEditExpenseVisible(true);
  };
  const handleCloseEditExpense = () => {
    setEditExpenseRecord(null);
    setIsEditExpenseVisible(false);
    handleRefreshPage();
  };

  const debouncedTemplateCallback = useDebouncedTemplateDataCallback();

  // useEffect(() => {
  //   fetchTemplates();
  // }, [fetchTemplates]);
  const homeAddress = filterMember?.addresses?.find(
    (addr) => addr.address_type === "home"
  );
  const mailingAddress = filterMember?.addresses?.find(
    (addr) => addr.address_type === "mailing"
  );

  const homeAddressParts = [
    homeAddress?.street,
    homeAddress?.state?.name,
    homeAddress?.county?.name,
    homeAddress?.city?.name,
    homeAddress?.zip_code?.name,
  ].filter(Boolean);
  const mailingAddressParts = [
    mailingAddress?.street,
    mailingAddress?.state?.name,
    mailingAddress?.county?.name,
    mailingAddress?.city?.name,
    mailingAddress?.zip_code?.name,
  ].filter(Boolean);

  const formattedHomeAddress = homeAddressParts.join(", ");
  const formattedMailingAddress = mailingAddressParts.join(", ");

  const stepOneSchema = Yup.object({
    newAuthorization: Yup.object({
      type: Yup.object()
        .required("Authorization Type is required")
        .nullable(),
    }),
  });

  const stepTwoSchema = (isDepositAuth) => Yup.object({
    newAuthorization: Yup.object({
      type: Yup.object()
        .required("Authorization Type is required")
        .nullable(),
      auth_no: Yup.string().required("Authorization Number is required"),
      startDate: Yup.date()
        .required("Start Date is required")
        .nullable(),
      endDate: Yup.date()
        .required("End Date is required")
        .nullable(),
      approvedDays: Yup.number()
        .required("Approved Days is required")
        .positive("Must be a positive number"),
      authorizedAmount: isDepositAuth
        ? Yup.number().notRequired()
        : Yup.number()
          .when("type", {
            is: (type) => type?.value === "housing_deposit",
            then: Yup.number()
              .required("Authorized Amount is required")
              .positive("Must be a positive number"),
            otherwise: Yup.number().notRequired(),
          }),

    }),
  });

  const getFullName = (value) => {
    if (!value) return "";
    return `${value?.first_name} ${value?.last_name}`;
  };

  // ────────────────────────────────────────────────
  // NEW: Exact same visibility logic as HousingExpenseRequestComp
  // ────────────────────────────────────────────────
  const getVisibleIcons = (row) => {
    const status = row?.status?.toLowerCase() || "";
    const createdByUserId =
      row?.created_by_user_id || row?.user_id || row?.created_by_id;

    const pendingApprovalUserId =
      row?.pending_approval_user_id ||
      row?.pending_approval_user?.id ||
      row?.pending_user_id ||
      row?.pending_approver_id ||
      null;

    const pendingApprovalRole =
      row?.pending_approval_role ||
      row?.pending_approval_user?.type ||
      row?.pending_role ||
      null;

    const icons = [];

    const isPendingForCurrentUser = () => {
      if (!pendingApprovalUserId || !currentUserId) return false;
      return String(pendingApprovalUserId) === String(currentUserId);
    };

    const isCreatedByCurrentUser = () => {
      if (!createdByUserId || !currentUserId) return false;
      return String(createdByUserId) === String(currentUserId);
    };

    const showView = () => {
      if (status === "draft") {
        return isCreatedByCurrentUser();
      }
      return true;
    };

    const showEdit = () => {
      if (isExecutive || isAccounting) return false;

      if (status === "draft") {
        return isCreatedByCurrentUser();
      }
      if (status === "submitted") {
        return isProgramCoordinator || isHousingNavigator || isCsManager;
      }
      if (status === "pending") {
        return false;
      }
      if (status === "approved") {
        return isProgramCoordinator || isHousingNavigator || isCsManager;
      }
      if (status === "completed") {
        return false;
      }
      if (status === "cancelled") {
        return isProgramCoordinator || isHousingNavigator || isCsManager;
      }
      if (status === "denied") {
        return isProgramCoordinator || isHousingNavigator || isCsManager;
      }
      return false;
    };

    const showApproveDeny = () => {
      const nextApprover = row?.next_approver?.trim();

      const loggedInEmail = userInfo?.email?.trim().toLowerCase();
      const approvalConfig =
        row?.expense_informations?.[0]?.approval_configuration;
      const executiveEmail = approvalConfig?.executive_email
        ?.trim()
        .toLowerCase();
      const accountingEmail = approvalConfig?.accounting_approval_email
        ?.trim()
        .toLowerCase();

      const roleMap = {
        Executive: isExecutive,
        Accounting: isAccounting,
        CsManager: isCsManager,
        ProgramCoordinator: isProgramCoordinator,
      };

      if (!roleMap[nextApprover]) return false;
      if (!canApproveReject) return false;

      const validStatuses = ["submitted", "pending", "housing-pending"];
      if (!validStatuses.includes(status?.toLowerCase())) return false;

      if (nextApprover === "Executive") {
        return executiveEmail === loggedInEmail;
      }

      if (nextApprover === "Accounting") {
        return accountingEmail === loggedInEmail;
      }
      if (nextApprover === "CsManager") {
        if (row?.member?.case_manager_id === userInfo?.id) return true;
      }
      if (nextApprover === "ProgramCoordinator") {
        return true;
      }
      return isPendingForCurrentUser();
    };

 const showDollarSign = () => {
      if (!isAccounting) return false;
      if (row?.status?.toLowerCase() === "draft") return false;
      if (row?.is_payment_confirmed) return false;

      const nextApprover = row?.next_approver?.trim();
      const approvalConfig =
        row?.expense_informations?.[0]?.approval_configuration;
      const accountingEmail = approvalConfig?.accounting_approval_email
        ?.trim()
        .toLowerCase();
      const loggedInEmail = userInfo?.email?.trim().toLowerCase();
      if (accountingEmail !== loggedInEmail) return false;
      if (nextApprover === "Accounting") return false;
      return true;
    };

    if (showApproveDeny()) {
      icons.push(X); // Reject
      icons.push(CheckIcon); // Approve
    }
    if (showDollarSign()) icons.push(CurrencyDollar);

    return icons;
  };

  const handleVisibleRejectPayment = (row) => {
    setIsRejectedPaymentVisible(true);
    setSelectedId(row);
  };

  const handleCloseRejectPayment = () => {
    setIsRejectedPaymentVisible(false);
    setSelectedId("");
  };

  const handleVisibleAcceptPayment = (row) => {
    setIsAcceptPaymentVisible(true);
    setSelectedId(row);
  };

  const handleCloseAcceptPayment = () => {
    setIsAcceptPaymentVisible(false);
    setSelectedId("");
  };

  const RejectHousingPaymentSubmission = async (id, data) => {
    try {
      const response = await RejectedHousingExpense(id, data);
      if (response) {
        handleCloseRejectPayment();
        handleRefreshPage();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const ApprovedHousingPaymentSubmission = async (id, data) => {
    try {
      const response = await ApprovedHousingExpense(id, data);
      if (response) {
        handleCloseAcceptPayment();
        handleRefreshPage();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const sortedSurveyList = useMemo(() => {
    if (!surveyList) return [];

    return [...surveyList].sort((a, b) => {
      return new Date(b.created_at) - new Date(a.created_at);
    });
  }, [surveyList]);


  return (
    <>
      <div className="row ms-4">
        <div className="col">
          {loading ? (
            <div className="loader-wrapper">
              <Loader />
            </div>
          ) : (
            <>
              <div className="row">
                <div className="col-12 col-sm-9 pe-sm-5">
                  <div className="main-header pb-0 mb-4">
                    <div className="arrow-and-content">
                      <ArrowLeft
                        className="opacity-50 mb-2 me-2 cursor-pointer"
                        size={24}
                        onClick={() => navigate(-1)}
                      />
                      <h3 className="space">
                        {capitalizeName(memberInfo.memberName)}
                        's History
                      </h3>
                    </div>
                    {/* <button
                      className={`survey-btn secondary-btn cursor-pointer `}
                      onClick={() => {
                        navigate(`/survey/${memberInfo.memberID}`, {
                          state: member,
                        });
                      }}
                    >
                      Start Survey
                    </button> */}
                  </div>
                </div>
              </div>
              <p className="heading-h4 d-block d-xl-none">Survey History</p>
              <div className="row">
                <div className="col-12 col-md-6 survey-table-wrapper">
                  <TableWrapper
                    isLoading={loading}
                    searchFeild={false}
                    pageSize={meta.perPage}
                    totalListCount={totalCount}
                    onPageChange={handlePageChange}
                    currentPage={meta.page}
                    actionButtons={
                      canCreateExpenseRequest
                        ? [
                          {
                            label: "Create Request",
                            classes: "primary-btn",
                            handleClick: () => {
                              setIsExpenseModalOpen(true);
                            },
                          },
                        ]
                        : []
                    }
                  >
                    <div
                      className="d-none d-xl-block"
                      style={{
                        position: "absolute",
                        top: "-42px",
                        left: "20px",
                      }}
                    >
                      <span className="heading-sm">
                        Authorization Amount Balance: ${calculateHDABalance()}
                      </span>
                    </div>
                    <div className="container-fluid ">
                      <div className="overflow-scroll boarder-radius-20px scrollable">
                        <table className="table table-rows ">
                          <thead className="table-header ">
                            <tr>
                              <th>
                                <div className="form-check p-0 mb-0"></div>
                              </th>
                              <th>Submitted Date</th>
                              <th>Submitted by</th>
                              <th>Expense Total</th>
                              <th>Approval Status</th>
                              {/* <th>Authorization Ids</th> */}
                              <th></th>
                            </tr>
                          </thead>

                          <tbody className="table-body">
                            {sortedSurveyList.map((survey, surveyIndex) => {
                              const icons = getVisibleIcons(survey);

                              return (
                                <>
                                  <tr key={surveyIndex}>
                                    <td>
                                      <div
                                        className={`d-flex justify-content-between align-items-center ms-3 me-3 ${showDetailsId === surveyIndex ? "active" : ""
                                          }`}
                                        onClick={() => {
                                          if (showDetailsId === surveyIndex) {
                                            setShowDetailsId("");
                                          } else {
                                            setShowDetailsId(surveyIndex);
                                          }
                                        }}
                                      >
                                        {/* {showQuestions ? (
                                          <div className="cursor-pointer">
                                            <CaretDown size={20} />
                                          </div>
                                        ) : (
                                          <div className="cursor-pointer">
                                            <CaretRight size={20} />
                                          </div>
                                        )} */}
                                      </div>
                                    </td>

                                    <td className="fw-bold  ">
                                      {formatDate(survey.created_at)}
                                    </td>
                                    <td className=" ">
                                      {capitalizeName(
                                        survey?.member?.first_name +
                                        " " +
                                        survey?.member?.last_name
                                      ) || ""}
                                    </td>
                                    {/* <td>
                                      {capitalizeName(survey?.ecm_status) ||
                                        ""}
                                    </td>

                                    <td className="fw-bold  ">
                                      {survey.template?.name}
                                    </td> */}
                                    <td className=" ">
                                      {survey?.expense_informations &&
                                        survey.expense_informations.length > 0
                                        ? `$${Number(
                                          survey.expense_informations.reduce(
                                            (acc, curr) =>
                                              acc +
                                              Number(
                                                curr.expense_amount || 0
                                              ),
                                            0
                                          )
                                        ).toFixed(2)}`
                                        : "$0.00"}
                                    </td>
                                    <td className=" ">
                                      <div
                                        className={`status ${getStatusConfig(survey.status).class
                                          } ps-1 pe-1`}
                                      >
                                        {getStatusConfig(survey.status).label}
                                      </div>
                                    </td>
                                    {/* <td className="fw-bold  ">
                                      {survey?.authorizations_ids}
                                    </td> */}
                                    <td className="d-flex align-items-center">
                                      <Tooltip title="View">
                                        <Eye
                                          size={24}
                                          className="ms-2 opacity-50"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handleOpenViewExpense(survey)
                                          }
                                        />
                                      </Tooltip>

                                      {!["completed", "pending"].includes(
                                        survey?.status?.toLowerCase()
                                      ) && (
                                          <Tooltip title="Edit">
                                            <Pencil
                                              size={24}
                                              className="ms-2 opacity-50"
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleOpenEditExpense(survey)
                                              }
                                            />
                                          </Tooltip>
                                        )}
                                      {survey?.status === "draft" && (
                                        <Tooltip title="Delete">
                                          <Trash
                                            size={24}
                                            className="ms-2 opacity-50"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              handleOpenDeleteModal(survey.id)
                                            }
                                          />
                                        </Tooltip>
                                      )}
                                      {icons.map((Icon, idx) => (
                                        <Tooltip
                                          key={idx}
                                          title={
                                            Icon === Pencil
                                              ? "Edit"
                                              : Icon === X
                                                ? "Deny"
                                                : Icon === CheckIcon
                                                  ? "Approve"
                                                  : Icon === CurrencyDollar
                                                    ? "Confirm Payment"
                                                    : ""
                                          }
                                        >
                                          <Icon
                                            size={22}
                                            className="ms-2 opacity-75 hover-opacity-100 cursor-pointer"
                                            onClick={() => {
                                              if (Icon === Pencil) {
                                                handleOpenEditExpense(survey);
                                              } else if (Icon === X) {
                                                handleVisibleRejectPayment(survey);
                                              } else if (Icon === CheckIcon || Icon === CurrencyDollar) {
                                                handleVisibleAcceptPayment(survey);
                                              }
                                            }}
                                          />
                                        </Tooltip>

                                      ))}
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </TableWrapper>
                  {/* <div className="d-flex justify-content-between align-items-center">
                    <h2>Tasks</h2>
                    <p
                      className=" text-secondary small m-0  w-100 text-end me-3 cursor-pointer"
                      onClick={() => {
                        setShowCompletedTaskModal(true);
                      }}
                    >
                      <Eye /> See Completed Tasks
                    </p>
                    <button
                      className={` w-25
                          secondary-btn
                      `}
                      onClick={() => setShowTaskModal(true)}
                    >
                      <Plus /> Add Task
                    </button>
                  </div> */}
                </div>
                <div className="col-12 col-md-5 survey-info">
                  {/* Assigned Outreach Staff */}
                  <p className=" d-flex gap-3 mb-0 mt-5 w-100 justify-content-between pe-5">
                    Key Details
                    <Pencil
                      size="24"
                      onClick={handleEditModal}
                      style={{ cursor: "pointer" }}
                    />
                  </p>
                  <div className="my-4 d-flex justify-content-between gap-3 ">
                    <button
                      className={` w-50 ${activeTab === "memberInfo"
                        ? "primary-btn"
                        : "secondary-btn"
                        }`}
                      onClick={() => setActiveTab("memberInfo")}
                    >
                      Member Info
                    </button>
                    <button
                      className={` w-50 ${activeTab === "housingLeadInfo"
                        ? "primary-btn"
                        : "secondary-btn"
                        }`}
                      onClick={() => setActiveTab("housingLeadInfo")}
                    >
                      Housing Lead Info{" "}
                    </button>
                  </div>

                  <div className="my-4 d-flex justify-content-between gap-3 ">
                    <button
                      className={` w-50  ${activeTab === "authorizations"
                        ? "primary-btn"
                        : "secondary-btn"
                        }`}
                      onClick={() => setActiveTab("authorizations")}
                    >
                      Authorizations
                    </button>
                    <button
                      className={` w-50 ${activeTab === "referralInfo"
                        ? "primary-btn"
                        : "secondary-btn"
                        }`}
                      onClick={() => setActiveTab("referralInfo")}
                    >
                      Referral Info
                    </button>
                    <button
                      className={` w-50 ${activeTab === "programenrollment"
                        ? "primary-btn"
                        : "secondary-btn"
                        }`}
                      onClick={() => setActiveTab("programenrollment")}
                    >
                      Program Enrollment
                    </button>
                  </div>
                  {activeTab === "authorizations" && (
                    <div className="my-4 d-flex justify-content-between gap-3 ">
                      <button
                        className="w-50 primary-btn"
                        onClick={() => setShowAuthPopup(true)}
                      >
                        Add Authorizations
                      </button>
                    </div>
                  )}
                  {activeTab === "memberInfo" ? (
                    <>
                      {/* Personal Info */}
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Personal Info </h5>
                        <div className="mt-1 grid-container">
                          <div className="row">
                            <div className="col-sm-6">
                              <HeaderCard
                                title="Name"
                                subTitle={capitalizeName(memberInfo.memberName)}
                              />
                            </div>
                            <div className="col-sm-6">
                              <HeaderCard
                                title="Date of Birth"
                                subTitle={
                                  memberInfo?.date_of_birth
                                    ? formatDate(memberInfo?.date_of_birth)
                                    : ""
                                }
                              />
                            </div>
                            <div className="col-sm-6">
                              <HeaderCard
                                title="Gender"
                                subTitle={
                                  capitalizeName(memberInfo?.gender) || ""
                                }
                              />
                            </div>
                            <div className="col-sm-6">
                              <HeaderCard
                                title="Race/Ethnicity"
                                subTitle={formatString(memberInfo?.race) || ""}
                              />
                            </div>
                            <div className="col-sm-6">
                              <HeaderCard
                                title="Health Plan"
                                subTitle={memberInfo.health_plan || ""}
                              />
                            </div>
                            <div className="col-sm-6">
                              <HeaderCard
                                title="Marital Status"
                                subTitle={
                                  capitalizeName(memberInfo?.marital) || ""
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Membership Info */}

                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3">Membership Info</h5>
                        <div className="mt-1 grid-container">
                          <div className="row">
                            <div className="col-sm-6">
                              <HeaderCard
                                title="CIN"
                                subTitle={memberInfo.cin}
                              />
                            </div>
                            <div className="col-sm-6">
                              <HeaderCard
                                title="AICA Master Person Index No."
                                subTitle={memberInfo.aica_account || ""}
                              />
                            </div>
                            <div className="col-sm-6">
                              <HeaderCard
                                title="KIPU Account No."
                                subTitle={memberInfo.kipu_account_no || ""}
                              />
                            </div>
                            {/* <div className="col-sm-6">
                              <HeaderCard
                                title="KIPU IFMRN"
                                subTitle={memberInfo.kipu_ifmrn || ""}
                              />
                            </div> */}
                            <div className="col-sm-6">
                              <HeaderCard
                                title="CSS Manager"
                                subTitle={
                                  memberInfo?.cs_manager
                                    ? `${memberInfo.cs_manager.first_name} ${memberInfo.cs_manager.last_name}`
                                    : ""
                                }
                              />
                            </div>
                            {/* <div className="col-sm-6">
                              <HeaderCard
                                title="Subscriber ID"
                                subTitle={memberInfo.subscriber_id || ""}
                              />
                            </div> */}
                            {/* <div className="col-sm-6">
                              <HeaderCard
                                title="Health Plan"
                                subTitle={memberInfo.health_plan || ""}
                              />
                            </div> */}

                            <div className="col-sm-4">
                              <HeaderCard
                                title="Housing Navigator"
                                subTitle={
                                  getFullName(memberInfo?.housing_navigator) ||
                                  ""
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Contact Info */}
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Contact Info</h5>
                        <div className="mt-1 d-flex  justify-content-between flex-column">
                          <HeaderCard
                            title="Phone"
                            subTitle={memberInfo?.phone || ""}
                          />
                          <HeaderCard
                            title="Email"
                            subTitle={memberInfo?.email || ""}
                          />
                          <HeaderCard
                            title="Home Address"
                            subTitle={formatString(formattedHomeAddress) || ""}
                          />
                          <HeaderCard
                            title="Mailing Address"
                            subTitle={
                              formatString(formattedMailingAddress) || ""
                            }
                          />
                        </div>
                      </div>

                      {/* Emergency Contact */}
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Emergency Contact</h5>
                        <div className="mt-1 d-flex justify-content-between  flex-wrap">
                          <HeaderCard
                            title="Emergency Contact Name"
                            subTitle={memberInfo?.emergency_contact_name || ""}
                          />
                          <HeaderCard
                            title="Emergency Contact Relationship"
                            subTitle={
                              capitalizeName(
                                memberInfo?.emergency_contact_relationship
                              ) || ""
                            }
                          />
                        </div>
                      </div>
                      {/* Communication Preferences */}
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Communication Preferences</h5>
                        <div className="mt-1 d-flex justify-content-between  flex-wrap">
                          <HeaderCard
                            title="Preferred Language Spoken"
                            subTitle={
                              memberInfo?.preferred_spoken_language || ""
                            }
                          />
                          <HeaderCard
                            title="Preferred Language Written"
                            subTitle={
                              memberInfo?.preferred_written_language || ""
                            }
                          />
                        </div>
                      </div>
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Other</h5>
                        <div className="mt-1 d-flex justify-content-between  flex-wrap">
                          <HeaderCard
                            title="Population of Focus"
                            subTitle={
                              memberInfo?.population_focuses ? (
                                formatString(memberInfo.population_focuses)
                                  .split(",")
                                  .map((item, index) => (
                                    <p key={index}>{item.trim()}</p>
                                  ))
                              ) : (
                                <p className="badge px-3 py-2 rounded-5 text-black-50 bg-secondary-subtle border-black  border-opacity-10 border-1 "></p>
                              )
                            }
                          />
                          <HeaderCard
                            title="Conditions"
                            subTitle={
                              memberInfo.conditions ? (
                                formatString(memberInfo.conditions)
                                  .split(",")
                                  .map((item, index) => (
                                    <p key={index}>{item.trim()}</p>
                                  ))
                              ) : (
                                <p className="badge px-3 py-2 rounded-5  text-black-50 bg-secondary-subtle border-black  border-opacity-10 border-1 "></p>
                              )
                            }
                          />
                        </div>
                      </div>
                      <h5 className="mt-3">Notes</h5>
                      <Input
                        type="textarea"
                        value={comment?.content}
                        onChange={handleCommentChange}
                        onBlur={handleCommentUpdationOrCreation}
                      />
                    </>
                  ) : activeTab === "housingLeadInfo" ? (
                    <div>
                      {/*Property Information*/}
                      <div className="w-100 mt-3 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                        <h5 className="mt-3 ">Property Information</h5>
                        <div className="mt-1 d-flex justify-content-between  flex-wrap">
                          <HeaderCard
                            title="Property"
                            subTitle={memberInfo?.housing_database?.property_name || ""}
                          />
                          <HeaderCard
                            title="Unit"
                            subTitle={memberInfo?.housing_unit || ""}
                          />
                          <HeaderCard
                            title="Landlord Name"
                            subTitle={memberInfo?.landlord_name || ""}
                          />
                        </div>
                      </div>
                    </div>
                  ) : activeTab === "referralInfo" ? (
                    <div>
                      <h5 className="mt-3">Referral Info</h5>
                      {memberInfo?.referrals?.map((referral, index) => (
                        <div className="mt-1 grid-container w-100 p-4 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3">
                          <div
                            key={index}
                            className="mt-1 d-flex flex-wrap gap-2"
                          >
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Created Date"
                                subTitle={referral?.created_at || ""}
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Referral Program"
                                subTitle={
                                  formatString(referral?.referral_programe) ||
                                  ""
                                }
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Status"
                                subTitle={
                                  capitalizeName(referral?.referral_status) ||
                                  ""
                                }
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Created By"
                                subTitle={referral?.created_by || ""}
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Referral Source"
                                subTitle={referral?.referral_source || ""}
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Referral Provider"
                                subTitle={referral?.referring_provider || ""}
                              />
                            </div>
                            {referral.approved_date && (
                              <div className="col-sm-3">
                                <HeaderCard
                                  title="Approved Date"
                                  subTitle={referral?.approved_date || ""}
                                />
                              </div>
                            )}
                            <div className="col-sm-3">
                              <HeaderCard
                                title="IF Number"
                                subTitle={referral?.if_number || ""}
                              />
                            </div>
                            <div className="col-sm-3">
                              <HeaderCard
                                title="Current Living Situation"
                                subTitle={referral?.current_living_situation || ""}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : activeTab === "programenrollment" ? (
                    <div className="w-100 mt-3">
                      <div className="p-4 border border-black border-opacity-10 bg-card-secondary rounded-3">

                        <h5 className="mb-4">Program Enrollment</h5>

                        {/* Headings */}
                        <div className="row fw-bold border-bottom pb-2 mb-3">
                          <div className="col-md-5">Program</div>
                          <div className="col-md-2">County</div>
                          <div className="col-md-5">IFMRN / Status</div>
                        </div>

                  {PROGRAMS.map((program) =>
                    program.counties.map(({ county, key, statusKey }) => {
                      const ifmrn = memberInfo?.[key]?.trim() || "";
                      const status = memberInfo?.[statusKey]?.toLowerCase() === "active" ? "Active" : "Inactive";

                      return (
                        <div key={key} className="row align-items-center border-bottom py-3">
                        <div className="col-md-5 fw-semibold">{program.name}</div>
                         <div className="col-md-2">{county}</div>
                           <div className="col-md-5 d-flex align-items-center gap-3">
                           <span>{ifmrn}</span>
                            <HeaderCard title="" subTitle={status} />
                        </div>
                       </div>
                      );
                    })
                  )}

                      </div>
                    </div>
                  ) : activeTab === "authorizations" ? (
                    <div className="w-100 ">
                      {/* <div className="d-flex justify-content-between">
                        <h5 className="mt-3">Authorization Info</h5>
                        <p className=" text-secondary small">
                          <Pencil
                            size={24}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const auth = memberInfo.authorizations[0] || {};
                              setSelectedAuth({
                                id: auth.id || Date.now(),
                                type:
                                  authTypes.find(
                                    (type) => type.label === auth.type
                                  ) || null,
                                auth_no: auth.auth_no || "",
                                startDate: auth.start_date
                                  ? moment(
                                      auth.start_date,
                                      "MM/DD/YYYY"
                                    ).toDate()
                                  : null,
                                endDate: auth.end_date
                                  ? moment(auth.end_date, "MM/DD/YYYY").toDate()
                                  : null,
                                approvedDays: auth.approved_days || "",
                                status: auth.status || "Active",
                              });
                              setShowAuthPopup(true);
                            }}
                          />
                        </p>
                      </div> */}
                      <div className="mt-1">
                        {memberInfo.expense_authorizations?.map(
                          (auth, index) => (
                            <div
                              key={index}
                              className="w-100 p-3 border border-black border-opacity-10 border-1 bg-card-secondary rounded-3 mb-3"
                            >
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h6 className="mb-0">
                                  Authorization #{index + 1}
                                </h6>
                                {/* <Pencil
                                  size={18}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    const selectedType =
                                      authTypes.find(
                                        (type) =>
                                          type.value === auth.auth_type ||
                                          type.label === auth.auth_type
                                      ) || null;

                                    setSelectedAuth({
                                      id: auth.id,
                                      type: selectedType,
                                      auth_no: auth.auth_no || "",
                                      startDate: auth.start_date ? auth.start_date : "",
                                      endDate: auth.end_date ? auth.end_date : "",
                                      approvedDays: auth.approved_days || "",
                                      authorizedAmount:
                                        auth.auth_type === "housing_deposit"
                                          ? auth.authorized_amount
                                          : "",
                                    });
                                    setIsEditingAuth(true);
                                    setShowAuthPopup(true);
                                  }}
                                /> */}
                              </div>
                              <div className="row">
                                {authFields.map((field) => {
                                  if (
                                    field.key === "authorized_amount" &&
                                    auth.auth_type !== "housing_deposit"
                                  ) {
                                    return null;
                                  }

                                  return (
                                    <div
                                      key={field.key}
                                      className="col-sm-6 mb-2"
                                    >
                                      <HeaderCard
                                        title={field.title}
                                        subTitle={
                                          field.key === "auth_type"
                                            ? getAuthTypeLabel(auth[field.key])
                                            : field.key === "authorized_amount"
                                              ? `$${auth[field.key] || ""}`
                                              : field.key === "start_date" ||
                                                field.key === "end_date"
                                                ? auth[field.key]
                                                  ? auth[field.key]
                                                  : ""
                                                : auth[field.key] || ""
                                        }
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )
                        )}

                        {(!memberInfo.expense_authorizations ||
                          memberInfo.expense_authorizations.length === 0) && (
                            <div className="text-center p-4">
                              <p className="text-muted">
                                No authorizations found
                              </p>
                            </div>
                          )}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {showDeleteConfirm && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseDeleteModal}
          heading={`Confirmation`}
        >
          <div className="question-modal">
            <hr className="custom-modal-line mt-0 " />

            <form className="form-main" onSubmit={() => { }}>
              <h6>Are you sure you want to delete this HousingExpense?</h6>

              <hr className="custom-modal-line mt-4" />

              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleCloseDeleteModal}
                >
                  Cancel
                </button>
                <button
                  className="primary-btn w-50"
                  type="button"
                  onClick={handleDeleteConfirm}
                >
                  Confirm
                </button>
              </div>
            </form>
          </div>
        </CustomModal>
      )}
      {isViewExpenseVisible && selectedExpenseRecord && (
        <CustomModal
          show={isViewExpenseVisible}
          onHide={handleCloseViewExpense}
          size="sm"
          heading={
            <div>
              View Request{" "}
              <span
                className={
                  getStatusConfig(selectedExpenseRecord?.status)?.class || ""
                }
              >
                {getStatusConfig(selectedExpenseRecord?.status)?.label ||
                  selectedExpenseRecord?.status ||
                  "—"}
              </span>
            </div>
          }
        >
          <h4 className="my-4">Member Information</h4>
          <div className="row">
            <div className="col-sm-4">
              <h6 className="my-6">Member's Name</h6>
              <p className="heading-sm">
                {`${selectedExpenseRecord?.member?.first_name || ""} ${selectedExpenseRecord?.member?.last_name || ""
                  }`.trim() || ""}
              </p>
            </div>
            <div className="col-sm-4">
              <h6 className="my-6">CIN</h6>
              <p className="heading-sm">{selectedExpenseRecord?.member?.cin || ""}</p>
            </div>
            <div className="col-sm-4">
              <h6 className="my-6">Payment Method</h6>
              <p className="heading-sm">
                {selectedExpenseRecord?.expense_informations?.[0]?.approval_configuration
                  ?.approval_method || ""}
              </p>
            </div>
               <div className="col-sm-4">
              <h6 className="my-6">Address</h6>
              <p className="heading-sm">
                   {showAddress(selectedExpenseRecord?.member?.addresses?.[1]) || ""}
              </p>
            </div>
            <div className="col-sm-4">
              <h6 className="my-6">Expense ID</h6>
              <p className="heading-sm">
              {selectedExpenseRecord?.expense_informations?.[0]?.housing_expense_id
                  || ""}
              </p>
              </div>
          </div>
          <hr className="mt-4" />
          <h4 className="my-4">Documents</h4>
          <div className="row">
            <div className="col-sm-4">
              <h6 className="my-6">W-9</h6>
              {selectedExpenseRecord?.upload_w9 && (
                <div className="mt-2">
                  <a
                    href={selectedExpenseRecord.upload_w9}
                    download={selectedExpenseRecord.upload_w9_file_name}
                    className="text-blue-500 cursor-pointer flex items-center gap-1"
                  >
                    <DownloadSimple size={25} />
                    {selectedExpenseRecord.upload_w9_file_name}
                  </a>
                </div>
              )}
            </div>

            <div className="col-sm-4">
              <h6 className="my-6">Lease Agreement</h6>
              {selectedExpenseRecord?.upload_lease_agreement && (
                <div className="mt-2">
                  <a
                    href={selectedExpenseRecord.upload_lease_agreement}
                    download={selectedExpenseRecord.upload_lease_agreement_file_name}
                    className="text-blue-500 cursor-pointer flex items-center gap-1"
                  >
                    <DownloadSimple size={25} />
                    {selectedExpenseRecord.upload_lease_agreement_file_name}
                  </a>
                </div>
              )}
            </div>

            <div className="col-sm-4">
              <h6 className="my-6">Authorization from Health Plan</h6>
              {selectedExpenseRecord?.upload_authorization && (
                <div className="mt-2">
                  <a
                    href={selectedExpenseRecord.upload_authorization}
                    download={selectedExpenseRecord.upload_authorization_file_name}
                    className="text-blue-500 cursor-pointer flex items-center gap-1"
                  >
                    <DownloadSimple size={25} />
                    {selectedExpenseRecord.upload_authorization_file_name}
                  </a>
                </div>
              )}
            </div>

            <div className="col-sm-4">
              <h6 className="my-6">Check Request</h6>
              {selectedExpenseRecord?.check_request_document && (
                <div className="mt-2">
                  <a
                    href={selectedExpenseRecord.check_request_document}
                    download={selectedExpenseRecord.check_request_file_name}
                    className="text-blue-500 cursor-pointer flex items-center gap-1"
                  >
                    <DownloadSimple size={25} />
                    {selectedExpenseRecord.check_request_file_name}
                  </a>
                </div>
              )}
            </div>

            <div className="col-sm-4">
              <h6 className="my-6">Other Documents</h6>
              {selectedExpenseRecord?.other_document && (
                <div className="mt-2">
                  <div className="d-flex items-center gap-2">
                    <a
                      href={
                        selectedExpenseRecord?.other_document instanceof File
                          ? URL.createObjectURL(selectedExpenseRecord?.other_document)
                          : selectedExpenseRecord?.other_document
                      }
                      download
                      className="text-blue-500 cursor-pointer flex items-center gap-1"
                    >
                      <DownloadSimple size={25} />
                      {selectedExpenseRecord.other_document_file_name}
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
          <hr className="mt-4" />
          <h4 className="my-4">Payment Info</h4>
                  <div className="row">
                    <div className="col-sm-4">
                      <h6 className="my-6">Date of Check</h6>
                      <p className="heading-sm">
                        {selectedExpenseRecord?.date_of_check
                          ? formatDate(selectedExpenseRecord.date_of_check)
                          : ""}
                      </p>
                    </div>
                    <div className="col-sm-4">
                      <h6 className="my-6">HP Submission Reimbursement Date</h6>
                      <p className="heading-sm">
                        {selectedExpenseRecord?.hp_submission_reimbursement_date
                          ? formatDate(selectedExpenseRecord.hp_submission_reimbursement_date)
                          : ""}
                      </p>                   
                    </div>
                    <div className="col-sm-4">
                      <h6 className="my-6">HP Payment Date</h6>
                      <p className="heading-sm">
                        {selectedExpenseRecord?.hp_payment_date
                          ? formatDate(selectedExpenseRecord.hp_payment_date)
                          : ""}
                      </p>
                    </div>
            <div className="col-sm-4">
              <h6 className="my-6">Total Expense</h6>
              <p className="heading-sm">
                $
                {selectedExpenseRecord?.expense_informations
                  ?.reduce(
                    (sum, info) => sum + parseFloat(info.expense_amount || 0),
                    0
                  )
                  .toFixed(2) || "0.00"}
              </p>
            </div>
            <div className="col-sm-4">
              <h6 className="my-6">Receipt</h6>
              {selectedExpenseRecord?.upload_receipt && (
                <div className="mt-2">
                  <a
                    href={selectedExpenseRecord.upload_receipt}
                    download={selectedExpenseRecord.upload_receipt_file_name}
                    className="text-blue-500 cursor-pointer flex items-center gap-1"
                  >
                    <DownloadSimple size={25} />
                    {selectedExpenseRecord.upload_receipt_file_name}
                  </a>
                </div>
              )}
            </div>
          </div>
          <hr className="mt-4" />
          <div className="row">
            <div className="col-sm-12">
              <h6 className="my-6">Comment</h6>
              <p className="heading-sm">{selectedExpenseRecord?.comment || ""}</p>
            </div>
          </div>
          <hr className="mt-4" />
          <ApprovalStepper housingExpense={selectedExpenseRecord} />
          <button
            className="secondary-btn w-100 mt-4"
            onClick={handleCloseViewExpense}
          >
            Close
          </button>
        </CustomModal>
      )}
      <CustomModal
        show={isEditExpenseVisible && !!editExpenseRecord}
        onHide={handleCloseEditExpense}
        size="md"
        heading={"Edit Housing Expense Request"}
      >
        {isEditExpenseVisible && editExpenseRecord && (
          <CreateHousingExpenseForm
            selectedMember={editExpenseRecord?.member || {}}
            expenseRecord={editExpenseRecord}
            onClose={handleCloseEditExpense}
          />
        )}
      </CustomModal>
      <CustomModal
        show={isExpenseModalOpen}
        onHide={handleExpenseModalClose}
        size="lg"
        heading={"Create Expense Request"}
      >
        <AddExpenseWithMember
          selectedExpense={selectedExpense}
          setSelectedExpense={setSelectedExpense}
          handleOpenAddNewMemberModal={handleOpenAddNewMemberModal}
          handleExpenseModalClose={handleExpenseModalClose}
          preSelectedMember={memberInfo}
          handleRefresh={handleRefreshPage}
        />
      </CustomModal>
      <CustomModal
        show={editMember}
        onHide={() => setEditMember(false)}
        size="sm"
        heading={"Edit Member"}
      >
        <Addmemberform
          handleQuestionSubmittion={handleMemberSubmission}
          handleClose={() => setEditMember(false)}
          selectedMember={editMemberData}
        />
      </CustomModal>
      {/* {addNewMemberModal && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseAddNewMemberModal}
          heading={`Add Member`}
        >
          <AddFormWithoutMember
            handleSubmitForm={""}
            handleClose={handleCloseAddNewMemberModal}
          />
        </CustomModal>
      )} */}
      {showTaskModal && (
        <CustomModal
          className=" task-modal"
          size="sm"
          show
          onHide={handleCloseTaskModal}
          heading={`${currentTaskEdit ? "Edit" : "Add"} Task`}
        >
          <AddTaskForm
            handleSubmittion={handleTaskSubmission}
            handleClose={handleCloseTaskModal}
            currentTaskEdit={currentTaskEdit}
            users={activeUsers}
          />
        </CustomModal>
      )}

      {showCompletedTaskModal && (
        <CustomModal
          // className=" task-modal"
          size="sm"
          show
          onHide={handleCloseCompletedTaskModal}
          heading={
            memberInfo?.tasks?.filter((task) => task?.status === "complete")
              ?.length > 0
              ? `Completed Tasks`
              : "No Task Complete"
          }
        >
          {memberInfo?.tasks
            ?.filter((task) => task?.status === "complete")
            ?.map((task) => (
              <div className="w-100 p-3 shadow-sm bg-white rounded-3 mt-2">
                <div
                  className="d-flex justify-content-between align-items-start h-auto"
                  style={{ height: "76px" }}
                >
                  {/* Left Section - Checkbox & Task Info */}
                  <div className="d-flex align-items-start">
                    <RadioButton checked={task.isCompleted || true} />

                    <div>
                      <p className="heading-smb mb-1 text-muted  ">
                        {task.name}
                      </p>
                      <div className="d-flex align-items-center">
                        <FileText className="me-1" size={16} />
                        <span
                          className="text-muted small"
                          style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {task.description}
                        </span>
                      </div>
                      <div className="d-flex align-items-center">
                        <User className="me-1" size={16} />
                        <span className="small">{task?.user?.name || ""}</span>
                      </div>
                    </div>
                  </div>

                  {/* Right Section - Dates & Edit Button */}
                  <div className="d-flex" style={{ height: "76px" }}>
                    <div className="d-flex flex-column align-items-end justify-content-between ">
                      <p
                        className={`status ${task.status === "complete"
                          ? "Enrolled"
                          : task.status === "in_progress"
                            ? "Excluded"
                            : "pending"
                          } ps-1 pe-1`}
                      >
                        {moment(task.due_date, "DD/MM/YYYY").format(
                          "MM/DD/YYYY"
                        )}
                      </p>

                      {/* <span className="badge bg-danger text-white px-2 py-1 mb-1">
                      {task.due_date}
                    </span> */}
                      <span className="text-muted small">
                        Created: {task.created_at}
                      </span>
                    </div>

                    {/* Edit Button */}
                    <button className="border-0 bg-transparent p-1 ms-3">
                      <Pencil size={18} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </CustomModal>
      )}

      {isTemplateModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseTemplateModal}
          heading="Choose Template"
        >
          <AsyncSelect
            label="Select Template"
            isRequired
            options={templatesList}
            loadOptions={(inputValue) =>
              new Promise((resolve) => {
                debouncedTemplateCallback(inputValue, resolve);
              })
            }
            selectedValue={selectedTemplate}
            placeholder="Select "
            handleChange={(obj) => {
              setSelectedTemplate(obj.value);
            }}
          />

          <div className="action gap-2">
            <button
              className="secondary-btn w-50"
              type="button"
              onClick={handleCloseTemplateModal}
            >
              Cancel
            </button>
            <button
              className="primary-btn w-50"
              type="button"
              disabled={!selectedTemplate}
              onClick={() => {
                navigate(`/survey/${memberInfo.id}`, {
                  state: {
                    ...memberInfo,
                    template_id: selectedTemplate,
                  },
                });
              }}
            >
              Start Survey
            </button>
          </div>
        </CustomModal>
      )}
      {showAuthPopup && (
        <CustomModal
          show={showAuthPopup}
          onHide={() => {
            setShowAuthPopup(false);
            setSelectedAuth(null);
            setIsEditingAuth(false);
            handleModalClose(() => { });
          }}
          size="sm"
          heading={
            isEditingAuth ? "Edit Authorization Info" : "Add Authorization Info"
          }
        >
          <Formik
            initialValues={{
              newAuthorization: {
                type: selectedAuth?.type || null,
                auth_no: selectedAuth?.auth_no || "",
                startDate: selectedAuth?.startDate || null,
                endDate: selectedAuth?.endDate || null,
                approvedDays: selectedAuth?.approvedDays || "",
                authorizedAmount: selectedAuth?.authorizedAmount || "",
              },
            }}
            validationSchema={modalStep === 1 ? stepOneSchema : stepTwoSchema(memberInfo?.is_deposit_auth)}
            onSubmit={(values, { setErrors }) => {
              console.log("Form submitted:", values);
              handleAuthSubmit(
                () => { },
                values,
                () => { },
                setErrors
              );
            }}
          >
            {({ setFieldValue, values, validateForm, errors }) => {
              return (
                <Form>

                  {modalStep === 1 && (
                    <>
                      <SelectComponent
                        name="newAuthorization.type"
                        label="Authorization Type"
                        options={authTypes}
                        handleChange={(obj) =>
                          setFieldValue("newAuthorization.type", obj)
                        }
                        placeholder="Select Authorization Type"
                        value={values.newAuthorization?.type || null}
                      />
                      <ErrorMessage
                        name={"newAuthorization.type"}
                        component="div"
                        className="text-danger small"
                      />
                    </>
                  )}
                  {modalStep === 2 && (
                    <div className="mt-4">
                      <div>
                        <SelectComponent
                          name="newAuthorization.type"
                          label="Authorization Type"
                          options={authTypes}
                          handleChange={(obj) =>
                            setFieldValue("newAuthorization.type", obj)
                          }
                          placeholder="Select Authorization Type"
                          value={values.newAuthorization?.type || null}
                        />
                        <ErrorMessage
                          name={"newAuthorization.type"}
                          component="div"
                          className="text-danger small"
                        />
                        {errors?.apiError && (
                          <div className="text-danger small">
                            {errors.apiError}
                          </div>
                        )}
                      </div>
                      <Field
                        name="newAuthorization.auth_no"
                        render={({ field }) => (
                          <Input
                            {...field}
                            placeholder="e.g. 123456"
                            type="text"
                            label="Authorization Number"
                            handleChange={(e) =>
                              setFieldValue(
                                "newAuthorization.auth_no",
                                e.target.value
                              )
                            }
                            value={values.newAuthorization?.auth_no || ""}
                          />
                        )}
                      />
                      <ErrorMessage
                        name="newAuthorization.auth_no"
                        component="div"
                        className="text-danger small"
                      />
                      <Field
                        name="newAuthorization.startDate"
                        render={({ field }) => (
                          <DateInput
                            label="Start Date"
                            name="newAuthorization.startDate"
                            placeholderText="Select Start Date"
                            placeholder="Select Start Date"
                            handleChange={(date) =>
                              setFieldValue("newAuthorization.startDate", date)
                            }
                            value={values.newAuthorization?.startDate || null}
                          />
                        )}
                      />
                      <ErrorMessage
                        name="newAuthorization.startDate"
                        component="div"
                        className="text-danger small"
                      />
                      <Field
                        name="newAuthorization.endDate"
                        render={({ field }) => (
                          <DateInput
                            label="End Date"
                            name="newAuthorization.endDate"
                            placeholderText="Select End Date"
                            placeholder="Select End Date"
                            handleChange={(date) =>
                              setFieldValue("newAuthorization.endDate", date)
                            }
                            value={values.newAuthorization?.endDate || null}
                          />
                        )}
                      />
                      <ErrorMessage
                        name="newAuthorization.endDate"
                        component="div"
                        className="text-danger small"
                      />
                      <Field
                        name="newAuthorization.approvedDays"
                        render={({ field }) => (
                          <Input
                            {...field}
                            placeholder="e.g. 30"
                            type="number"
                            label="Approved Number of Days"
                            handleChange={(e) =>
                              setFieldValue(
                                "newAuthorization.approvedDays",
                                e.target.value
                              )
                            }
                            value={values.newAuthorization?.approvedDays || ""}
                          />
                        )}
                      />
                      <ErrorMessage
                        name="newAuthorization.approvedDays"
                        component="div"
                        className="text-danger small"
                      />
                      {!memberInfo?.is_deposit_auth &&
                        values.newAuthorization.type?.value ===
                        "housing_deposit" && (
                          <>
                            <Field
                              name="newAuthorization.authorizedAmount"
                              render={({ field }) => (
                                <Input
                                  {...field}
                                  placeholder="e.g. 1000.00"
                                  type="number"
                                  isRequired
                                  step="0.01"
                                  label="Authorized Amount"
                                  handleChange={(e) =>
                                    setFieldValue(
                                      "newAuthorization.authorizedAmount",
                                      e.target.value
                                    )
                                  }
                                  value={
                                    values.newAuthorization?.authorizedAmount || ""
                                  }
                                />
                              )}
                            />
                            <ErrorMessage
                              name="newAuthorization.authorizedAmount"
                              component="div"
                              className="text-danger small"
                            />
                          </>
                        )
                      }
                    </div>
                  )}
                  <div className="d-flex justify-content-between mt-4">
                    <button
                      type="button"
                      className="secondary-btn w-50 me-2"
                      onClick={() => handleModalClose(setFieldValue)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="primary-btn w-50"
                      // onClick={() =>
                      //   handleAuthSubmit(setFieldValue, values, validateForm)
                      // }
                      disabled={modalStep === 1 && !values.newAuthorization?.type}
                    >
                      {modalStep === 1
                        ? isEditingAuth
                          ? "Edit Authorization Info"
                          : "Add Authorization Info"
                        : isEditingAuth
                          ? "Update Authorization"
                          : "Add Authorization"}
                    </button>
                  </div>
                </Form>
              )
            }}
          </Formik>
        </CustomModal>
      )}

      {/* ────────────────────────────────────────────────
           NEW: Approve / Deny / Confirm Payment Modals
      ──────────────────────────────────────────────── */}
      <CustomModal
        show={isRejectedPaymentVisible}
        onHide={handleCloseRejectPayment}
        size="sm"
        heading={"Deny Expense Request"}
      >
        <RejectForm
          onCancel={handleCloseRejectPayment}
          handleSubmission={RejectHousingPaymentSubmission}
          selectedId={selectedId?.id}
        />
      </CustomModal>

      <CustomModal
        show={isAcceptPaymentVisible}
        onHide={handleCloseAcceptPayment}
        size="sm"
        heading={
          selectedId?.status === "approved" ? (
            "Confirm Payment Issuance"
          ) : (
            <span>
              Approve housing expense request for
              <br />
              {`${selectedId?.member?.first_name} ${selectedId?.member?.last_name}`}
            </span>
          )
        }
      >
        {selectedId?.status === "approved" ? (
          <PaymentForm
            onClose={handleCloseAcceptPayment}
            handleSubmission={ApprovedHousingPaymentSubmission}
            selectedId={selectedId?.id}
          />
        ) : (
          <HousingPaymentForm
            onClose={handleCloseAcceptPayment}
            handleSubmission={ApprovedHousingPaymentSubmission}
            selectedId={selectedId?.id}
          />
        )}
      </CustomModal>
    </>
  );
};

export default SurveyHistory;
